import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './lista.css';
import OBR from "@owlbear-rodeo/sdk";

const idApp = "com.covildovelhodragao";
async function fetchCharacter(characterId) {
    try {
        const response = await fetch(`https://olddragon.com.br/personagens/${characterId}.json`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        if (!response.ok) {
            throw new Error(`Erro na requisição: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Erro ao buscar personagem:', error);
        return null;
    }
}



function Home() {
    const [personagensData, setPersonagensData] = useState([]);
    const navigate = useNavigate();
    const [campanha = false, setCampanhaId] = useState(null);
    const [isMestre, setIsMestre] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    // Busca os dados quando o componente é montado
    useEffect(() => {
        OBR.onReady(() => {

            const fetchData = async () => {
                const role = await OBR.player.getRole(); // Obtém o papel do usuário
                setIsMestre(role === "GM"); // GM = Game Master (Mestre)
                const storedToken = await OBR.room.getMetadata();
                console.log('token', storedToken[idApp]);
                if (typeof storedToken[idApp] === 'undefined' || storedToken[idApp] === null) {
                } else {
                    setCampanhaId(true);
                    const response = await fetch(`https://olddragon.com.br/campanhas/${storedToken[idApp].campanha}.json`, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                        }
                    });
                    const data = await response.json();
                    const resultados = await Promise.all(
                        data.personagens.map((p) => fetchCharacter(p.id))
                    );
                    setPersonagensData(resultados.map((res) => res));
                }
            };
            fetchData();
        });
    }, [campanha]); // Array vazio significa que só roda uma vez, ao montar


    const irParaFicha = (id) => {
        // OBR.notification.show(`Id da ficha ${id}`);
        // OBR.modal.open({
        //     id: `/ficha?id=${id}`,
        //     url: `/extension/ficha?id=${id}`,
        //     height: 500,
        //     width: 600,
        // });
        navigate(`/ficha?id=${id}`); // Redireciona com o id na query
    };

    async function saveCampanha() {
        try {
            const url = document.getElementById('url').value;
            const parts = url.split("/");
            const campanhaId = parts[parts.length - 1];
            
            const response = await fetch(`https://olddragon.com.br/campanhas/${campanhaId}.json`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            console.log(response);
            if (!response.ok) {
                throw new Error(`Erro na requisição: ${response.status}`);
            }
            OBR.room.setMetadata({ [idApp]: { "campanha": campanhaId } });
            const data = await response.json();
            setCampanhaId(true);
        } catch (error) {
            console.error('Erro ao buscar campanha:', error);
            return null;
        }
    }

    async function removeCampanha() {
        OBR.room.setMetadata({ [idApp]: null });
        setCampanhaId(false);
    }

    return (
        campanha ? (
            <div className="personagens">
                {isMestre && (
                    <button class="waves-effect waves-light btn" onClick={() => removeCampanha()}>
                        Remover Campanha
                    </button>
                )}
                
                {isLoading ? (
                    <div className="loader">Carregando...</div>
                  ) : (
                personagensData.map((person, index) => (
                    <div
                        class="row character"
                        onClick={() => irParaFicha(person.id)}
                    >
                        <div class="col s3">
                            <img
                                src={person.picture}
                                alt={person.name}
                                className="img-person"
                            />
                        </div>
                        <div class="col s9">
                            <h5 class="name">{person.name}</h5>
                            <span>
                                {person.character_race_name} ◆ {person.character_class_name} ◆
                                Nível {person.level}
                            </span>
                        </div>
                    </div>
                )))}
            </div>
        ) : (
            <div class="row">
                <div class="col s12">
                    <h5>Campanha não encontrada</h5>
                    <span>Por Favor insira o Url da sua campanha abaixo.</span>
                </div>
                <div class="input-field col s12">
                    <input id="url" type="text"></input>
                </div>
                <center><button class="waves-effect waves-light btn" onClick={saveCampanha} >Inserir Campanha</button></center>
            </div>
        )
    );


}

export { Home };